import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import { FiCheckCircle, FiShoppingCart, FiXCircle } from "react-icons/fi";
const Orders = (props) => {
  const { loading, error, orders } = props;
  if (loading) return <Loading />;

  if (error)
    return (
      <Message variant="bg-red-100 text-red-700 border border-red-400">
        {error}
      </Message>
    );
  return (
    <div className="flex flex-col items-center justify-center w-full">
      {orders.length === 0 ? (
        <div className="w-full bg-blue-50 text-blue-700 text-center p-6 rounded-lg mt-3 shadow">
          <FiShoppingCart className="inline-block text-2xl mr-2" />
          Không có đơn đặt hàng
          <Link
            to="/"
            className="ml-3 inline-block bg-green-500 hover:bg-green-600 text-white text-sm px-4 py-2 rounded-lg transition"
          >
            BẮT ĐẦU MUA SẮM
          </Link>
        </div>
      ) : (
        <div className="overflow-x-auto w-full mt-6 shadow-lg rounded-lg">
          <table className="min-w-full text-sm text-left border border-gray-200 rounded-lg overflow-hidden">
            <thead className="bg-gray-100 text-gray-700 uppercase text-xs tracking-wider">
              <tr>
                <th className="px-6 py-3 border-b">Mã đơn</th>
                <th className="px-6 py-3 border-b">Trạng thái</th>
                <th className="px-6 py-3 border-b">Ngày</th>
                <th className="px-6 py-3 border-b">Tổng cộng</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {orders?.map((order) => (
                <tr
                  key={order._id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-3 font-medium">
                    <a
                      href={`/order/${order._id}`}
                      className="text-blue-600 hover:underline"
                    >
                      {order._id}
                    </a>
                  </td>
                  <td className="px-6 py-3 flex items-center gap-2">
                    {order.isPaid ? (
                      <>
                        <FiCheckCircle className="text-green-500" />
                        <span className="text-green-700">Đã thanh toán</span>
                      </>
                    ) : (
                      <>
                        <FiXCircle className="text-red-500" />
                        <span className="text-red-700">Chưa thanh toán</span>
                      </>
                    )}
                  </td>
                  <td className="px-6 py-3 text-gray-600">
                    {order.isPaid
                      ? moment(order.paidAt).calendar()
                      : moment(order.createdAt).calendar()}
                  </td>
                  <td className="px-6 py-3 font-semibold text-gray-800">
                    {order.totalPrice.toLocaleString()}₫
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
